import axios, { HttpStatusCode } from 'axios'
import type { IRestPasswordRequest } from './auth.service'

/**
 * @description validate the OTP for forgot password
 * @param username The username of the user
 * @param otp The OTP entered by the user
 * @returns The response object containing the user details
 */
const verifyForgotPasswordOtp = async (username: string, otp: string) => {
  return await axios
    .post('/api/register/verifyResetPasswordOtp', { username: username, otp: otp })
    .then(async (response) => {
      if (response && response.status === HttpStatusCode.Ok) {
        return response
      }
    })
    .catch((error) => {
      throw error
    })
}

/**
 * @description validate the OTP for registered user
 * @param username The username of the user
 * @param otp The OTP entered by the user
 * @returns The response object containing the user details
 */
const verifyRegisteredPasswordOtp = async (username: string, otp: string) => {
  return await axios
    .post('/api/register/verifyOtpRegistration', { username: username, otp: otp })
    .then(async (response) => {
      if (response.status === HttpStatusCode.Ok) {
        return response
      }
    })
    .catch((error) => {
      throw error
    })
}

/**
 * @description resend the OTP for registered user
 * @param username The username of the user
 * @returns The response object containing the user details
 */
const resendRegisteredOtp = async (username: string) => {
  return await axios
    .post('/api/register/regenerateOtp', { username: username })
    .then(async (response) => {
      if (response.status === HttpStatusCode.Ok) {
        return response
      }
    })
    .catch((error) => {
      throw error
    })
}

/**
 * @param restPasswordRequest The reset password request object containing user credentials
 * @description This function is used to reset the user's password
 * @returns The response object containing the user details
 */
const resetForgotPasswordUsingOtp = async (restPasswordRequest: IRestPasswordRequest) => {
  return await axios
    .post('/api/register/resetPassword', restPasswordRequest)
    .then((response) => {
      return response
    })
    .catch((error) => {
      throw error
    })
}

export default {
  verifyForgotPasswordOtp,
  verifyRegisteredPasswordOtp,
  resendRegisteredOtp,
  resetForgotPasswordUsingOtp
}
